<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.preApprovedTemplates')}}
                    </label>
                </div>
                <div class="col-auto">
                    <router-link to="/PreApprovedTemplates/Add" tag="button" class="btn btn-primary">
                        <span class="text_sm_hidden">{{$t('shared.addPreApprovedTemplate')}}</span>
                        <i class="fas fa-plus px-2"></i>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row mb-3">

                        <div class="col-md-3">
                            <input class="form-control"
                                   type="text"
                                   v-model="filterModel.name"
                                   :placeholder="$t('shared.templateName')" />
                        </div>

                        <div class="col-md-3">
                            <v-select style="width: 100%;"
                                      v-model="filterModel.classification"
                                      :items="classificationList"
                                      item-text="name"
                                      item-value="id"
                                      :placeholder="$t('shared.classification')"
                                      solo
                                      dense
                                      clearable
                                      @change="onClassificationChanged"
                                      attach>
                            </v-select>
                        </div>

                        <div class="col-md-3">
                            <v-menu v-model="createdDateFromMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    lazy
                                    full-width
                                    min-width="290px"
                                    offset-y attach>
                                <template v-slot:activator="{ on }">
                                    <div class="input-group">
                                        <input class="form-control border-right-0 border-left"
                                               v-model="filterModel.createdDateFrom"
                                               :placeholder="$t('shared.createdDateFrom')"
                                               readonly
                                               ref="createdDatePickerFrom" v-on="on" type="text" />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text right gray">
                                                <i class="far fa-calendar-alt"></i>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <v-date-picker v-model="filterModel.createdDateFrom"
                                               no-title
                                               scrollable
                                               @input="onDateChange('from')">
                                </v-date-picker>
                            </v-menu>
                        </div>

                        <div class="col-md-3">
                            <v-menu v-model="createdDateToMenu"
                                    :close-on-content-click="false"
                                    lazy
                                    full-width
                                    :nudge-right="40"
                                    min-width="290px"
                                    transition="scale-transition" offset-y attach>
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="input-group">
                                        <input class="form-control border-right-0 border-left"
                                               v-model="filterModel.createdDateTo"
                                               :placeholder="$t('shared.createdDateTo')"
                                               readonly v-bind="attrs"
                                               ref="createdDatePickerTo" v-on="on" type="text" />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text right gray">
                                                <i class="far fa-calendar-alt"></i>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <v-date-picker v-model="filterModel.createdDateTo"
                                               no-title
                                               scrollable
                                               @input="onDateChange('to')">
                                </v-date-picker>
                            </v-menu>
                        </div>

                        <div class="col-md-12 mb-3 mt-3">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto">
                                    <button type="button" @click="resetFilter" class="btn btn-danger btn-action">
                                        {{$t('shared.reset')}}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <template>
                        <v-data-table :headers="headers"
                                      :items="templates"
                                      :total-items="totalCount"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center" :title="props.item.templateCode">{{ props.item.templateCode }}</td>
                                    <td class="text-center">{{ props.item.name }}</td>
                                    <td class="text-center">{{ classificationLabel(props.item.classification) }}</td>
                                    <td class="text-center">{{ formatDate(props.item.createdDate) }}</td>
                                    <td class="text-center">
                                        <span class="text-truncate d-inline-block" style="max-width: 220px;" :title="props.item.templateContent">
                                            {{ props.item.templateContent }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <v-switch v-model="props.item.isActive" @change="toggleActivation(props.item)"></v-switch>
                                    </td>
                                    <td class="text-center">
                                        <router-link :to="'/PreApprovedTemplates/Details/' + props.item.id" tag="a" class="mx-1">
                                            <i class="fas fa-info-circle Icon_Info"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>